import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};

const AdminAuthCheck = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch('/api/admin/Authorization', {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Auth Check" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminLogin = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/admin/login', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const LoginOtp = async (body) => {
    const token = localStorage.getItem('token');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/login/otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const GetAdminData = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/admin/AdminData`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminProfileUpdate = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/Profile/Update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ForgetPw = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPw`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ForgetPwOtp = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPwOtp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ResetPassword = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/NewPassword`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Mobile
const mobileFetch = async (body) => {
    const encrypted = encryptResponse(body);
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch('/api/mobile/fetch', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileImport = async (body) => {
    const encrypted = encryptResponse(body);
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch('/api/mobile/admin/import', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileGet = async (page, limit, query) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/mobile/admin?page=${page}&limit=${limit}&search=${query}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Mobile Get" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileStop = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/mobile/admin/import/stop`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Mobile Stop" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileImportExal = async (formdata) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch('/api/mobile/admin/import/exal', {
            method: "POST",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: formdata
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileDelete = async (body) => {
    const encrypted = encryptResponse(body);
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch('/api/mobile/admin', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Server Load Checker
const GetServerLoadCheck = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/server/load/check`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Native Ads
const getNativeAds = async (group) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateNativeAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addNativeAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNativeAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

//  Get all groups
const getNativeAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneNativeAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/native/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteNativeAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/native/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeNativeAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/native/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const nativeAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/native/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Full Screen Ads
const getFullScreenAds = async (group = 'A') => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateFullScreenAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addFullScreenAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteFullScreenAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

//  Get all groups
const getFullScreenAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneFullScreenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteFullScreenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeFullScreenAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const fullScreenAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Banner Ads
const getBannerAds = async (group) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBannerAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');

    try {
        const resp = await fetch(`/api/app/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBannerAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteBannerAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Banner Group
const getBannerAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneBannerAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteBannerAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeBannerAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const bannerAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Open Ads
const getOpenAds = async (group) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addOpenAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateOpenAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');

    try {
        const resp = await fetch(`/api/app/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteOpenAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Open Group
const getOpenAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneOpenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteOpenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeOpenAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const openAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Reward Ads
const getRewardAds = async (group) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addRewardAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');

    try {
        const resp = await fetch(`/api/app/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateRewardAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteRewardAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Group
const getRewardAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneRewardAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteRewardAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeRewardAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const rewardAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// RewardFs Ads
const getRewardFsAds = async (group) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateRewardFsAds = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addRewardFsAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteRewardFsAds = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

//  Get all groups
const getRewardFsAdGroups = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneRewardFsAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteRewardFsAdGroup = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeRewardFsAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const rewardFsAdsGroupSwap = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/rewardFs/admin/swap-group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Controller
const getControleData = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/App/controller/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControllerFacebook = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {

        const resp = await fetch(`/api/App/controller/admin/facebook/change`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// User Login Data
const getAllUserLogin = async (page, startDate, endDate, limit, q, sort) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/user/login/admin/all/data?page=${page}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&q=${q}&sort=${sort}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUserLogin = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/login/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// User Managemaent
const getAllUserData = async (page, startDate, endDate, limit, q, sort, block) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/user/admin/all/data?page=${page}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&q=${q}&sort=${sort}&block=${block}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const blockUser = async (id, status) => {
    const token = localStorage.getItem('admin_trucaller');
    const body = {
        status: status
    }
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/block/${id}`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUser = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const userInfo = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/user/admin/all/info/show/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateUserInfo = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/update/data/${id}`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Dashbord
const adminDashbord = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_trucaller');
    try {

        const resp = await fetch(`/api/admin/home/dashboard?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Api Config
const getApiConfig = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/mobile/admin/api-config`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const putApiConfig = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/mobile/admin/api-config`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Policy 
const getPolicy = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/policy/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updatePolicy = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/policy/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Terms
const getTerms = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/terms/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateTerms = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/terms/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}
// Ios Policy 
const getIosPolicy = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/policy/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosPolicy = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/policy/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Terms
const getIosTerms = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/terms/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosTerms = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/terms/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}


// Notification
const getNotification = async (page, limit) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/notification/admin/history?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const sendNotification = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/notification/admin/send`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const resendNotification = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/admin/resend`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNotification = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// const CallNotification = async (formData) => {
//     const token = localStorage.getItem('admin_trucaller');

//     try {
//         const resp = await fetch(`/api/app/notification/admin/call`, {
//             method: "POST",
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'x-api-key': api_key,
//             },
//              body: formData,
//         });
//         return handleApiResponse(resp);
//     } catch (error) {
//         return { status: false, message: "Internet Server Error" };
//     }
// }

// const ResendCallNotification = async (body) => {
//     const token = localStorage.getItem('admin_trucaller');
//     const encrypted = encryptResponse(body);
//     try {
//         const resp = await fetch(`/api/app/notification/admin/recall`, {
//             method: "POST",
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//                 'x-api-key': api_key,
//             },
//             body: JSON.stringify({ encryptedData: encrypted }),
//         });
//         return handleApiResponse(resp);
//     } catch (error) {
//         return { status: false, message: "Internet Server Error" };
//     }
// }

// Auto Notification
const getAutoNotConfig = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/autonotification/config/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateAutoNotConfig = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/autonotification/config/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Auto Notification Templates
const getAutoNotTemplates = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/autonotification/template/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addAutoNotTemplate = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/autonotification/template/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateAutoNotTemplate = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/autonotification/template/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteAutoNotTemplate = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/autonotification/template/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


const setControleUpdate = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/controller/admin/update`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Showbox
const getShowbox = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/showbox/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateShowbox = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/showbox/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Showbox Analtytic
const getShowboxAnalytic = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/showbox/admin/analytic?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteShowboxAnalytic = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/showbox/admin/analytic?startDate=${startDate}&endDate=${endDate}`, {
            method: "delete",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Views Dashbord and Click Dashbord
const adminViewsDashbord = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_trucaller');
    try {

        const resp = await fetch(`/api/admin/view/dashboard/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// In House Ads
const uploadInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAds = async (page, limit, q) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/inhouse?a=true&page=${page}&limit=${limit}&q=${q}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setInHouseAdsStatus = async (id, status) => {
    const token = localStorage.getItem('admin_trucaller');
    const body = {
        id,
        status
    }
    const encrypted = encryptResponse(body);

    try {

        const resp = await fetch(`/api/app/ads/inhouse/update/status`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInhouseAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAdsData = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/inhouse/data/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Ads Tracker
const adminAdsTrackDashbord = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_trucaller');
    try {

        const resp = await fetch(`/api/app/ads/track/analytic/admin?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const adminAdsTrackDelete = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_trucaller');
    try {

        const resp = await fetch(`/api/app/ads/track/analytic/admin?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// AdsTxt
const getAdsTxt = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/admin/ads/txt`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateAdsTxt = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ads/txt`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Whitelist Number
const getWhitelistNumber = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/whitelist/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateWhitelistNumber = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/whitelist/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addWhitelistNumber = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/whitelist/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteWhitelistNumber = async (body) => {
    const token = localStorage.getItem('admin_trucaller');

    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/whitelist/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Rate Limit
const getRateLimitEvents = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/admin/ratelimit`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteRateLimitEvent = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ratelimit/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const changeRateLimitStatus = async (id, status) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse({ status });

    try {
        const resp = await fetch(`/api/admin/ratelimit/${id}/status`, {
            method: "PATCH",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const getWhitelist = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/admin/ratelimit/whitelist/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const addWhitelist = async (ip, reason) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse({ ip, reason });
    try {
        const resp = await fetch(`/api/admin/ratelimit/whitelist/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const removeWhitelist = async (ip) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse({ ip });
    try {
        const resp = await fetch(`/api/admin/ratelimit/whitelist/remove`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Ip To Detail Service
const getIpToDetail = async (ip) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/admin/ip-to-detail/${ip}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    }
    catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Search
const adminSearch = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/mobile/admin/search`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Ios
const getIosNativeAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosNativeAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosNativeAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getIosFullScreenAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosFullScreenAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner Ads
const getIosBannerAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosBannerAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosBannerAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Ads
const getIosOpenAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/open/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosOpenAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosOpenAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Ads
const getIosRewardAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosRewardAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosRewardAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// RewardFs Ads
const getIosRewardFsAds = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/ios/ads/rewardfs/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosRewardFsAds = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/rewardfs/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosRewardFsAds = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/rewardfs/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Json Manager
const getJsonManage = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ui/jsonmanager/admin?a=true`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addJsonManager = async (formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ui/jsonmanager/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateJsonmanager = async (id, formData) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/ui/jsonmanager/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Report Bug
const addReportBug = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/reportbug/admin/add`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReportBug = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/reportbug/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteReportBug = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/reportbug/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateReportBug = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/reportbug/admin/update/${id}`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addReportBugHistory = async (body) => {
    const token = localStorage.getItem('token');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/reportbug/admin/add-history`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReportBugHistory = async (page = 1, limit = 10, startDate = '', endDate = '') => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        let query = `?page=${page}&limit=${limit}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;

        const resp = await fetch(`/api/app/reportbug/admin/get-history${query}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const bulkDeleteReportBugHistory = async (ids) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse({ ids });
    try {
        const resp = await fetch(`/api/app/reportbug/admin/bulk-delete-history`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Plan
const getPlan = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/plan/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const createPlan = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/plan/admin`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updatePlan = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/plan/admin/${id}`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deletePlan = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse({ id });
    try {
        const resp = await fetch(`/api/app/plan/admin/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Plan Histroy 
const getPlanHistory = async (page = 1, limit = 10, startDate = '', endDate = '', userId = '', status = '', sort = '', search = '') => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        let query = `?page=${page}&limit=${limit}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        if (userId) query += `&userId=${userId}`;
        if (status) query += `&status=${status}`;
        if (sort) query += `&sort=${sort}`;
        if (search) query += `&search=${search}`;

        const resp = await fetch(`/api/app/plan/admin/purchase${query}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const sendAdminPlan = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/plan/admin/send`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const detelePurchasePlan = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/plan/admin/purchase/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Referral History
const getReferral = async (page = 1, limit = 10, startDate = '', endDate = '', status = '', sort = '', search = '', userId = '') => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        let query = `?page=${page}&limit=${limit}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        if (status) query += `&status=${status}`;
        if (sort) query += `&sort=${sort}`;
        if (search) query += `&q=${search}`;
        if (userId) query += `&userId=${userId}`;

        const resp = await fetch(`/api/app/referral/admin${query}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteReferral = async (ids) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/referral/admin`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ id: ids }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Referral Plans
const getReferralPlans = async () => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/referral/admin/plan`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addReferralPlan = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/referral/admin/plan`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateReferralPlan = async (id, body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/referral/admin/plan/${id}`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteReferralPlan = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/referral/admin/plan/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Referral Plan History
const getReferralPlanHistory = async (page = 1, limit = 10, startDate = '', endDate = '', status = '', sort = '', search = '', userId = '') => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        let query = `?page=${page}&limit=${limit}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        if (status) query += `&status=${status}`;
        if (sort) query += `&sort=${sort}`;
        if (search) query += `&q=${search}`;
        if (userId) query += `&userId=${userId}`;

        const resp = await fetch(`/api/app/referral/admin/plans/history${query}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteReferralPlanHistory = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/referral/admin/plans/history`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReferralPlanHistoryById = async (id) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        const resp = await fetch(`/api/app/referral/admin/plans/history/user/${id}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getMultipleReferralPlanPurchaseUsers = async (page = 1, limit = 10) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        // Build query params
        const query = new URLSearchParams({
            page,
            limit,
        }).toString();

        const resp = await fetch(
            `/api/app/referral/admin/multiple-plan-users?${query}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': api_key,
                },
            }
        );

        return handleApiResponse(resp);
    } catch (error) {
        return {
            status: false,
            message: "Internet Server Error"
        };
    }
};

// Delete Request
const getDeleteRequest = async (
    {
        page = 1,
        limit = 10,
        status,
        search
    } = {}
) => {
    const token = localStorage.getItem('admin_trucaller');

    try {
        // Build query params
        const query = new URLSearchParams({
            page,
            limit,
            ...(status !== undefined && { status }),
            ...(search && { search })
        }).toString();

        const resp = await fetch(
            `/api/app/user/admin/delete/request?${query}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': api_key,
                },
            }
        );

        return handleApiResponse(resp);
    } catch (error) {
        return {
            status: false,
            message: "Internet Server Error"
        };
    }
};

const rejectDeleteRequest = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete/request`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const acceptDeleteRequest = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete/request/accept`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const sendRequestDelete = async (body) => {
    const token = localStorage.getItem('admin_trucaller');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/delete/request/web`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getMultiplePlanPurchaseUsers = async (page = 1, limit = 10) => {
    const token = localStorage.getItem('admin_trucaller');
    try {
        // Build query params
        const query = new URLSearchParams({
            page,
            limit,
        }).toString();

        const resp = await fetch(
            `/api/app/plan/admin/check/multiple-purchase?${query}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': api_key,
                },
            }
        );

        return handleApiResponse(resp);
    } catch (error) {
        return {
            status: false,
            message: "Internet Server Error"
        };
    }
};




const Calling = {
    AdminLogin, AdminAuthCheck, ResetPassword, LoginOtp, GetAdminData, AdminProfileUpdate, ForgetPw, ForgetPwOtp,
    adminDashbord, adminViewsDashbord,
    adminAdsTrackDashbord, adminAdsTrackDelete,
    mobileFetch, mobileImport, mobileGet, mobileStop, mobileImportExal, mobileDelete,
    GetServerLoadCheck,
    getAllUserLogin, deleteUserLogin,
    getAllUserData, blockUser, deleteUser, userInfo, updateUserInfo,
    getNativeAds, updateNativeAds, addNativeAds, deleteNativeAds,
    getFullScreenAds, addFullScreenAds, updateFullScreenAds, deleteFullScreenAds,
    getBannerAds, addBannerAds, updateBannerAds, deleteBannerAds,
    getOpenAds, addOpenAds, updateOpenAds, deleteOpenAds,
    getRewardAds, addRewardAds, updateRewardAds, deleteRewardAds,
    getRewardFsAds, addRewardFsAds, updateRewardFsAds, deleteRewardFsAds,
    getFullScreenAdGroups, cloneFullScreenAdGroup, deleteFullScreenAdGroup, changeFullScreenAdGroupTitle, fullScreenAdsGroupSwap,
    getOpenAdGroups, deleteOpenAdGroup, cloneOpenAdGroup, changeOpenAdGroupTitle, openAdsGroupSwap,
    getBannerAdGroups, cloneBannerAdGroup, deleteBannerAdGroup, changeBannerAdGroupTitle, bannerAdsGroupSwap,
    getRewardAdGroups, cloneRewardAdGroup, deleteRewardAdGroup, changeRewardAdGroupTitle, rewardAdsGroupSwap,
    getRewardFsAdGroups, cloneRewardFsAdGroup, deleteRewardFsAdGroup, changeRewardFsAdGroupTitle, rewardFsAdsGroupSwap,
    getNativeAdGroups, cloneNativeAdGroup, deleteNativeAdGroup, changeNativeAdGroupTitle, nativeAdsGroupSwap,
    getControleData, setControllerFacebook, setControleUpdate,
    getApiConfig, putApiConfig,
    getPolicy, updatePolicy, getTerms, updateTerms,
    getIosPolicy, updateIosPolicy, getIosTerms, updateIosTerms,
    getNotification, sendNotification, resendNotification, deleteNotification,

    // CallNotification,ResendCallNotification,
    getAutoNotConfig, updateAutoNotConfig,
    getAutoNotTemplates, addAutoNotTemplate, updateAutoNotTemplate, deleteAutoNotTemplate,
    getShowbox, updateShowbox,
    getInHouseAds, uploadInHouseAds, setInHouseAdsStatus, deleteInhouseAds, getInHouseAdsData, updateInHouseAds,
    getShowboxAnalytic, deleteShowboxAnalytic,
    getAdsTxt, updateAdsTxt,
    getWhitelistNumber, updateWhitelistNumber, addWhitelistNumber, deleteWhitelistNumber,
    getRateLimitEvents, deleteRateLimitEvent, removeWhitelist, addWhitelist, getWhitelist, changeRateLimitStatus,
    getIpToDetail,
    adminSearch,
    getIosNativeAds, updateIosNativeAds, addIosNativeAds,
    getIosFullScreenAds, updateIosFullScreenAds, addIosFullScreenAds,
    getIosBannerAds, updateIosBannerAds, addIosBannerAds,
    getIosOpenAds, updateIosOpenAds, addIosOpenAds,
    getIosRewardAds, updateIosRewardAds, addIosRewardAds,
    getIosRewardFsAds, addIosRewardFsAds, updateIosRewardFsAds,
    getJsonManage, addJsonManager, updateJsonmanager,
    // Report Bug
    addReportBug, getReportBug, deleteReportBug, updateReportBug,
    addReportBugHistory, getReportBugHistory, bulkDeleteReportBugHistory,

    // Plan
    createPlan, getPlan, updatePlan, deletePlan,

    // Plan History
    getPlanHistory, sendAdminPlan, detelePurchasePlan, getMultiplePlanPurchaseUsers,

    // Referral
    getReferral, deleteReferral,

    // Referral Plans
    getReferralPlans, addReferralPlan, updateReferralPlan, deleteReferralPlan,

    // Referral Plan History
    getReferralPlanHistory, deleteReferralPlanHistory, getReferralPlanHistoryById, getMultipleReferralPlanPurchaseUsers,

    // Delete Request
    getDeleteRequest, rejectDeleteRequest, acceptDeleteRequest, sendRequestDelete,



}

export default Calling;